module.exports = __webpack_public_path__ + "img/top_logo.3df8751a.svg";